import React, { useEffect, useState } from "react";
import { Modal, Icon, Button, message, Tag, Input, Checkbox, Select, Badge, Popover, DatePicker, Cascader } from "antd";
import { useWatchState, usePage } from "@/store";
import { BaseService } from "@/service";
import { checkResult, createSelectOption, second2Date, loadRegions, disabledLastDate } from "@/common";
import { TouchContainer } from "@/container";
import { isNullObject } from "@/check";
import { arr2Dic } from "@/utils";
import "./style.less";

const { Search, TextArea } = Input;
const { RangePicker } = DatePicker;
const NAME = "pushApply";

const View = () => {

    const [[REGIONS = []]] = useWatchState(["$_REGIONS"]);
    const [[SCOPE = []]] = useWatchState(["$_SCOPE"]);
    const [[INDUSTRY = []]] = useWatchState(["$_INDUSTRY"]);
    const [[DEMAND_ACTIVITY_TYPE = []]] = useWatchState(["$_DEMAND_ACTIVITY_TYPE"]);

    const [[props, setProps]] = useWatchState(["modal." + NAME])
    const { title = "推送配置", show, hide, type, state, callback, pushGroupId, targetPushTitle, targetPushTitleParams, targetPushRemark, defaultItems, showList = true } = props;
    const name = { result: "成果", demand: "需求" }[type]
    const table = { result: "thtt_chengguo", demand: "thtt_xuqiu" }[type]
    const key = { result: "chengguo_id", demand: "xuqiu_id" }[type]

    const [pushTitle, setPushTitle] = useState();
    const [pushTitleParams, setPushTitleParams] = useState();
    const [titleParams, setTitleParams] = useState({
        source: [],
        date: "",
        scopes: undefined,
        activity: undefined,
    });

    const clear = () => {
        setSelected({
            items: {},
        });
        setPushTitle("");
        setPushReamrk("");
    }

    const setTitleParamsHandler = (field, e) => {
        titleParams[field] = e;
        setTitleParams({ ...titleParams });
    }
    useEffect(() => {
        const { source, scopes, date, activity } = titleParams;
        setPushTitleParams(`${(scopes && scopes.label) ? "（" + scopes.label + "）" : ""}${source && source.map(({ label }) => label).join("")} ${date ? date.format("YYYY年MM月DD日") : ""}${(activity && activity.label) ? " - " + activity.label : ""}`)
    }, [titleParams])

    useEffect(() => {
        if (defaultItems && state == "add") {
            selected.items = arr2Dic(defaultItems, ["xuqiu_id", "name"])
            setSelected({ ...selected })
        }
    }, [defaultItems])

    useEffect(() => {
        if (state === "add" && show && table) {
            if (!defaultItems) clear();
            setTitleParams({
                source: [],
                date: "",
                scopes: undefined,
                activity: undefined,
            })
            setPushTitle("");
            setPushReamrk("");
            itemsControl.clear();
            itemsControl.go(1);
        }
    }, [state]);

    useEffect(() => {
        if (pushGroupId && table) {
            clear();
            getSelected(pushGroupId);
            itemsControl.clear();
            itemsControl.go(1);
        }
    }, [pushGroupId]);

    useEffect(() => {
        if (targetPushTitle) setPushTitle(targetPushTitle);
        if (targetPushTitleParams) setPushTitleParams(targetPushTitleParams);
        if (targetPushRemark) setPushReamrk(targetPushRemark);
    }, [targetPushTitle]);

    const [pushReamrk, setPushReamrk] = useState();
    const [itemScope, setItemScope] = useState();
    const [itemIndustry, setItemIndustry] = useState();
    const [itemActivity, setItemActivity] = useState();
    const [isTagging, setIsTagging] = useState(1);
    const [isPushed, setIsPushed] = useState(0);
    const [dateRange, setDateRange] = useState(0);

    const [keyword, setKeyword] = useState(0);

    const [selected, setSelected] = useState({
        items: {},
    })

    const getSelected = push_group_id => {
        BaseService.list({
            table: "thtt_push_group_items",
            leftJoin: {
                table,
                on: `${table}.${key} = thtt_push_group_items.item_id`,
                columns: JSON.stringify(["name"])
            },
            where: { push_group_id },
        }).then(res => {
            if (!checkResult(res)) return;
            let items = {};
            res.data.result.forEach(({ item_id, name }) => items[item_id] = name);
            selected.items = items;
            setSelected({ ...selected });
        })
    }

    const [items = [], itemsControl] = usePage({
        atonce: false,
        cache: true,
        service: BaseService.list,
        size: 20,
        params: {
            table,
            columns: key + ",name,contacts,contacts_tel,profile,is_tagging,add_time",
            leftJoin: JSON.stringify([
                {
                    table: "thtt_organization",
                    on: `thtt_organization.organization_id = ${table}.unit`,
                    columns: JSON.stringify(["profile AS orgProfile"])
                },
                ...(itemScope && itemScope.length ? [{
                    table: `${table}_scope`,
                    on: `${table}.${key} = ${table}_scope.${key}`,
                    columns: JSON.stringify(["first_scope_id"])
                }] : []),
            ]),
            where: JSON.stringify([
                { [`${table}.is_delete`]: 0, is_tagging: isTagging, is_pushed: isPushed },
                ...((itemScope && itemScope.length) || (itemIndustry && itemIndustry.length) ? ["AND"] : []),
                ...((itemScope && itemScope.length) ? [{ [`${table}_scope.first_scope_id`]: JSON.stringify(itemScope.map(({ key }) => key)) }] : []),
                ...((itemIndustry && itemIndustry.length) ? [{
                    [`${table}.industry_id`]: {
                        operator: "LIKE",
                        value: JSON.stringify(itemIndustry.map(({ key }) => key))
                    }
                }] : []),
                ...(itemActivity && itemActivity.length ? ["AND", {
                    [`${table}.activity_id`]: {
                        operator: "LIKE",
                        value: JSON.stringify(itemActivity.map(({ key }) => key))
                    }
                }] : []),
                ...(dateRange && dateRange.length ? ["AND", {
                    [`${table}.add_time_min`]: {
                        field: "thtt_xuqiu.add_time",
                        operator: ">",
                        value: parseInt(dateRange[0]._d.getTime() / 1000)
                    },
                    [`${table}.add_time_max`]: {
                        field: "thtt_xuqiu.add_time",
                        operator: "<",
                        value: parseInt(dateRange[1]._d.getTime() / 1000)
                    },
                }] : []),
                ...(keyword ? ["AND", {
                    [`${table}.name`]: {
                        value: keyword,
                        operator: "LIKE"
                    }
                }] : []),
            ]),
            process: JSON.stringify([
                {
                    name: "scopes",
                    key: "xuqiu_id",
                    targetKey: "xuqiu_id",
                    params: {
                        table: "thtt_xuqiu_scope",
                        columns: "second_scope_id",
                        leftJoin: {
                            table: "thtt_scope",
                            on: "thtt_xuqiu_scope.second_scope_id = thtt_scope.id",
                            columns: JSON.stringify(["name AS scopeName"])
                        }
                    }
                },
                {
                    name: "pushs",
                    key: "xuqiu_id",
                    targetKey: "item_id",
                    params: {
                        table: "thtt_push_group_items",
                        columns: "id,item_id,push_wechat_ids",
                        leftJoin: {
                            table: "thtt_push_wechat",
                            on: "thtt_push_group_items.push_wechat_ids = thtt_push_wechat.id",
                            columns: JSON.stringify(["title", "remark", "push_status", "push_time"])
                        },
                        where: {
                            "thtt_push_group_items.push_state": 2
                        },
                        process: {
                            name: "orgs",
                            key: "push_wechat_ids",
                            targetKey: "push_id",
                            params: {
                                table: "thtt_push_wechat_orgs",
                                columns: "id",
                                leftJoin: {
                                    table: "thtt_organization",
                                    on: "thtt_push_wechat_orgs.org_id = thtt_organization.organization_id",
                                    columns: JSON.stringify(["name AS orgName"])
                                }
                            }
                        }
                    }
                }
            ]),
            order: JSON.stringify([table + ".add_time DESC"])
        },
        format: res => res.data.result.records
    })

    useEffect(() => {
        if (show && table) {
            itemsControl.clear();
            itemsControl.go(1);
        }
    }, [itemScope, itemIndustry, itemActivity, isTagging, isPushed, dateRange, keyword])

    const add = async () => {
        if (!pushTitle) return message.warn("请设置推送标题");
        if (!pushReamrk) return message.warn("请设置推送备注");
        if (isNullObject(selected.items)) return message.warn("请选择要推送的" + name);
        const item_type = { result: 1, demand: 2 }[type];
        const res = await BaseService.add({
            table: "thtt_push_group",
            data: {
                title: pushTitle,
                title_params: pushTitleParams,
                remark: pushReamrk,
                item_type,
                add_time: new Date().format("yyyy-MM-dd hh:mm:ss")
            }
        });
        if (!checkResult(res)) return;
        const push_group_id = res.data.result.id;
        BaseService.adds({
            table: "thtt_push_group_items",
            data: JSON.stringify(Object.keys(selected.items).map(item_id => ({ push_group_id, item_id, item_type })))
        })
        if (callback) callback();
        hide();
    }

    const put = async () => {
        const item_type = { result: 1, demand: 2 }[type];
        BaseService.put({
            table: "thtt_push_group",
            data: {
                title: pushTitle,
                remark: pushReamrk,
                title_params: pushTitleParams,
            },
            where: { id: pushGroupId }
        })
        BaseService.remove({
            table: "thtt_push_group_items",
            where: { push_group_id: pushGroupId }
        }).then(delRes => {
            if (!checkResult(delRes)) return;
            BaseService.adds({
                table: "thtt_push_group_items",
                data: JSON.stringify(Object.keys(selected.items).map(item_id => ({ push_group_id: pushGroupId, item_id, item_type })))
            })
        })
        if (callback) callback();
        hide();
    }

    const finish = async () => {
        ({ add, put }[state])();
    }
    // 删除已选的成果/需求
    const onCloseItemTag = key => {
        delete selected.items[key]
        setSelected({ ...selected });
    }
    // 关键字搜索
    const onSearchItem = key => {
        setKeyword(key);
    }
    const onChangeItemSelected = (id, name, e) => {
        if (e.target.checked) selected.items[id] = name;
        else delete selected.items[id];
        setSelected({ ...selected });
    }

    return (
        <Modal
            title={title}
            visible={show}
            width="80vw"
            maskClosable={false}
            onCancel={hide}
            footer={(
                <div className="flex row-end child-left-sm">
                    <Button type="primary" onClick={finish}>提交</Button>
                    <Button onClick={hide}>取消</Button>
                </div>
            )}
        >
            <div className="child-top-sm">

                <div className="flex child-left-sm child-full">
                    <Input value={pushTitleParams} disabled={true} maxLength={100} placeholder="推送主题" />
                    <Input value={pushTitle} onChange={e => setPushTitle(e.target.value)} maxLength={100} placeholder="推送主题" />
                </div>
                <div className="child-left-sm">
                    <Select value={titleParams.scopes} style={{ minWidth: "150px" }} onChange={setTitleParamsHandler.later("scopes")} placeholder="请选择领域" labelInValue allowClear>
                        {createSelectOption(SCOPE)}
                    </Select>
                    <Cascader
                        value={titleParams.source.map(({ value }) => value)}
                        options={REGIONS}
                        changeOnSelect
                        loadData={loadRegions}
                        onChange={(e, o) => setTitleParamsHandler("source", o)}
                        className={titleParams.source.length && "mockInput"}
                        placeholder={titleParams.source.length ? titleParams.source.map(({ label }) => label).join(" / ") : '请选择需求来源！'}
                    />
                    <DatePicker value={titleParams.date} onChange={setTitleParamsHandler.later("date")} disabledDate={disabledLastDate} />
                    <Select value={titleParams.activity} style={{ minWidth: "150px" }} onChange={setTitleParamsHandler.later("activity")} placeholder="请选择活动类型" labelInValue allowClear>
                        {createSelectOption(DEMAND_ACTIVITY_TYPE)}
                    </Select>
                </div>
                <TextArea className="self-top--small" value={pushReamrk} onChange={e => setPushReamrk(e.target.value)} maxLength={200} placeholder="推送主题说明" />
                <div className="m-push flex child-full child-left-md self-top--small">

                    {/* 成果需求列表 */}
                    <div className="child-top-sm">
                        {/* 已选的成果 ｜ 需求 */}
                        <p className="bold">已打包需求</p>
                        <div className="over-auto border p-sm radius-5" style={{ height: "10vh", minHeight: "80px" }}>
                            {isNullObject(selected.items) ? <p className="dark-disable">已选{name}</p> : Object.entries(selected.items).map(([key, name]) => (
                                <Tag closable onClose={onCloseItemTag.later(key)}>{name}</Tag>
                            ))}
                        </div>
                        {/* 待选列表 */}
                        {showList && <div className="child-top-sm">
                            <div className="flex child-left-sm">
                                <Search onSearch={onSearchItem} />
                                <Select style={{ minWidth: "150px" }} onChange={setItemScope} placeholder="请选择领域" mode="multiple" labelInValue>
                                    {createSelectOption(SCOPE)}
                                </Select>
                                <Select style={{ minWidth: "150px" }} onChange={setItemIndustry} placeholder="请选择行业" mode="multiple" labelInValue>
                                    {createSelectOption(INDUSTRY)}
                                </Select>
                                <Select style={{ minWidth: "150px" }} onChange={setItemActivity} placeholder="请选择活动类型" mode="multiple" labelInValue>
                                    {createSelectOption(DEMAND_ACTIVITY_TYPE)}
                                </Select>
                            </div>
                            <div className="flex child-left-sm">
                                <Select style={{ minWidth: "100px" }} defaultValue={1} onChange={setIsTagging} placeholder="请选择标注状态">
                                    {createSelectOption([{ label: "已标注", value: 1 }, { label: "未标注", value: 0 }])}
                                </Select>
                                <Select style={{ minWidth: "100px" }} defaultValue={0} onChange={setIsPushed} placeholder="请选择推送状态">
                                    {createSelectOption([{ label: "推送过", value: 1 }, { label: "未推送过", value: 0 }])}
                                </Select>
                                <RangePicker onChange={setDateRange} />
                            </div>
                            <TouchContainer onScrollBottom={itemsControl.next} className="border-b child-border-t over-auto" style={{ height: "50vh" }}>
                                {items.map(vo => (
                                    <div className="p-sm flex between child-left-md">
                                        <Checkbox
                                            style={{ width: "30%" }}
                                            className="nowrap--ellipsis"
                                            checked={vo[key] && selected.items[vo[key]]}
                                            onChange={onChangeItemSelected.later(vo[key], vo.name)}>{vo.name}</Checkbox>

                                        {vo.is_tagging ? <span className="nowrap" style={{ color: "green" }}>已标注</span> : <span className="nowrap" style={{ color: "red" }}>未标注</span>}
                                        <span>{second2Date(vo.add_time)}</span>
                                        <span>已推送 {(vo.pushs || []).length} 次</span>
                                        <div style={{ width: "20%" }} className="font-size-12 nowrap--ellipsis">{vo.scopes.map(({ scopeName }) => scopeName).join(" ") || "-"}</div>

                                        <Popover content={(
                                            <div className="child-top-sm" style={{ width: "300px" }}>
                                                <div className="flex child-left-md">
                                                    <p className="child-left--mini"><Icon type="user" /><span>{vo.contacts || "未知"}</span></p>
                                                    <p className="child-left--mini"><Icon type="phone" /><span>{vo.contacts_tel || "未知"}</span></p>
                                                </div>
                                                <p className="font-size-18 bold">{name}简介</p>
                                                <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.profile }} />
                                                <p className="font-size-18 bold">机构简介</p>
                                                <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.orgProfile }} />
                                                <p className="font-size-18 bold">推送记录</p>
                                                <div className="over-auto">
                                                    {vo.pushs.map(({ remark, title, push_time, orgs, push_status }) => (
                                                        <div>
                                                            <p className="child-left-sm">
                                                                <span>{title}</span>
                                                                <span>{remark}</span>
                                                                {push_time && <span>{new Date(push_time).format("yyyy-MM-dd")}</span>}
                                                                <span>{[
                                                                    <Badge color="#2db7f5" className="nowrap" text="预推送" />,
                                                                    <Badge status="success" className="nowrap" text="已推送" />,
                                                                ][push_status]}</span>
                                                            </p>
                                                            <div>
                                                                {orgs.map(({ orgName }) => <p>{orgName}</p>)}
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <p></p>
                                                </div>
                                            </div>
                                        )} title={vo.name} trigger="click">
                                            <Icon type="info-circle" />
                                        </Popover>
                                    </div>
                                ))}
                            </TouchContainer>
                        </div>}
                    </div>

                </div>
            </div>
        </Modal>
    );
}

export default View;